import { el, clear } from '../../utils/dom.js';
import { Loans, Documents } from '../../api/resources.js';
import { fmtDateTime } from '../../utils/format.js';
import { dataTable } from '../../components/table.js';
import { statusBadge } from '../../components/badge.js';
import { openModal, confirm } from '../../components/modal.js';
import { field, readForm } from '../../components/form.js';
import { PhotoUpload } from '../../components/photo-upload.js';
import { ok, err } from '../../components/toast.js';
import { downloadFile, openFile } from '../../api/client.js';

export default async function LoansDetailPage(outlet, ctx) {
  clear(outlet);
  const id = ctx.params.id;
  let loan;
  try { loan = await Loans.get(id); }
  catch (ex) { outlet.innerHTML = `<div class="empty">Error: ${ex.message}</div>`; return; }

  const canReturn = ['activo','parcial','vencido'].includes(loan.status);

  outlet.appendChild(el('div', { class: 'page-head' },
    el('div', {},
      el('h1', {}, loan.code),
      el('div', { class: 'muted' }, statusBadge(loan.status), ' · ', loan.responsible_name),
    ),
    el('div', { class: 'flex gap-2' },
      el('a', { href: '#/loans', class: 'btn ghost' }, '← Volver'),
      el('button', { class: 'btn', onclick: () => openFile(Documents.loanReceiptPath(id)).catch((ex) => err(ex.message)) }, '📄 PDF'),
      canReturn ? el('button', { class: 'btn primary', onclick: openReturn }, 'Registrar devolucion') : null,
    ),
  ));

  const info = el('div', { class: 'card mb-4' },
    el('div', { class: 'card-head' }, el('h3', {}, 'Datos del prestamo')),
    el('div', { style: 'display:grid;grid-template-columns:repeat(3,1fr);gap:var(--sp-3);' },
      kv('Responsable', loan.responsible_name),
      kv('Cargo', loan.responsible_position),
      kv('Estado', statusBadge(loan.status)),
      kv('Fecha de salida', fmtDateTime(loan.start_date)),
      kv('Devolucion esperada', fmtDateTime(loan.expected_return_date)),
      kv('Devolucion real', loan.actual_return_date ? fmtDateTime(loan.actual_return_date) : '—'),
      kv('Registrado por', loan.registered_by_name),
      kv('Notas', loan.notes || '—'),
    ),
  );
  outlet.appendChild(info);

  const itemsCard = el('div', { class: 'card' },
    el('div', { class: 'card-head' }, el('h3', {}, `Items (${(loan.items || []).length})`)),
    dataTable({
      columns: [
        { key: 'item_name', label: 'Item' },
        { key: 'serial_number', label: 'Serial / Codigo', render: (r) => el('span', { class: 'text-mono text-sm' }, r.serial_number || r.unit_internal_code || (r.item_kind === 'bulk' ? 'BULK' : '—')) },
        { key: 'quantity', label: 'Cantidad', className: 'right' },
        { key: 'returned_quantity', label: 'Devuelto', className: 'right' },
        { key: 'condition_out', label: 'Estado salida', render: (r) => r.condition_out || '—' },
        { key: 'condition_in',  label: 'Estado entrada', render: (r) => r.condition_in || '—' },
        { key: 'status', label: 'Estado linea', render: (r) => statusBadge(r.status) },
        { key: '_act', label: '', className: 'right', render: (r) => canReturn && r.status !== 'devuelto' && r.status !== 'perdido' ? el('button', {
          class: 'btn sm danger',
          onclick: async () => {
            const reason = prompt('Motivo de la perdida:') || '';
            if (!reason) return;
            try { await Loans.markLost(id, r.id, reason); ok('Marcado como perdido'); LoansDetailPage(outlet, ctx); }
            catch (ex) { err(ex.message); }
          },
        }, 'Marcar perdido') : null },
      ],
      rows: loan.items || [],
    }),
  );
  outlet.appendChild(itemsCard);

  function openReturn() {
    const photos = PhotoUpload({ label: 'Fotos al recibir' });
    const form = el('form', {
      onsubmit: async (e) => {
        e.preventDefault();
        const data = readForm(form);
        try {
          await Loans.fullReturn(id, {
            actual_return_date: data.actual_return_date ? new Date(data.actual_return_date).toISOString() : undefined,
            condition_in: data.condition_in || undefined,
            photos_in: photos.getUrls(),
            notes: data.notes || undefined,
          });
          ok('Devolucion registrada');
          modal.close();
          LoansDetailPage(outlet, ctx);
        } catch (ex) { err(ex.message); }
      },
    });
    form.append(
      field({ name: 'actual_return_date', label: 'Fecha de devolucion', type: 'datetime-local', value: toLocalInput(new Date()) }),
      field({ name: 'condition_in', label: 'Estado al recibir', placeholder: 'p.ej. excelente, bueno, regular' }),
      photos.root,
      field({ name: 'notes', label: 'Notas', type: 'textarea' }),
    );
    const cancel = el('button', { class: 'btn', type: 'button', onclick: () => modal.close() }, 'Cancelar');
    const submit = el('button', { class: 'btn primary', type: 'submit' }, 'Confirmar devolucion');
    const modal = openModal({ title: `Devolver prestamo ${loan.code}`, body: form, footer: [cancel, submit] });
  }
}

function kv(label, value) {
  return el('div', {},
    el('div', { class: 'text-xs muted' }, label),
    el('div', { class: 'text-bold' }, value || '—'),
  );
}
function toLocalInput(d) {
  const pad = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}
